import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Button, Table, Label
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import { Redirect } from "react-router-dom"
import DetailBloc from './Blocs/DetailBloc'
import ReportBloc from '../Report/Blocs/ReportBloc'
import moment from 'moment';
import ReportDetailModal from '../Report/Components/ReportDetailModal';

class IndexView extends Component {

    detailBloc = new DetailBloc()
    reportBloc = new ReportBloc()

    constructor(props) {
        super(props)
        const userdata = JSON.parse(localStorage.getItem('userdata'));
        this.state = {
            document: null,
            atasan: null,
            userdata: userdata,
            currentRoleId: localStorage.getItem('currentRoleId'),
            reportDetail: null
        }
    }

    toggleDetail = () => {
        this.setState({ modalDetail: !this.state.modalDetail })
    }

    dateParse = (input) => {
        let res = "-";
        if (input != "" && input != null) {
            res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }
    loadAtasan = () => {
        const queryParams = new URLSearchParams(this.props.location.search)
        const currentRoleId = localStorage.getItem('currentRoleId')
        const userdata = JSON.parse(localStorage.getItem('userdata'))
        let params = { uuid: queryParams.get('uuid') }
        if (currentRoleId == 2) {
            params.employee_uuid = userdata?.employee_uuid
            params.employee_nip = userdata?.employee_nip
        }
        this.reportBloc.fetchAtasan(params)
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document: response.document_letter
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.reportBloc.atasanChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response

                        let notDone = 0;
                        // console.log(response)
                        this.setState({
                            atasan: response.employee_full_name
                        })
                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.loadAtasan()
        const queryParams = new URLSearchParams(this.props.location.search)
        const currentRoleId = localStorage.getItem('currentRoleId')
        const userdata = JSON.parse(localStorage.getItem('userdata'))
        let params = { uuid: queryParams.get('uuid') }
        if (currentRoleId == 2) {
            params.employee_uuid = userdata?.employee_uuid
        }
        this.detailBloc.fetchDetail(params)
    }

    componentWillUnmount() {
        this.detailBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Pengajuan WFH</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Pengajuan WFH
                                    </CardSubtitle> */}
                                    <hr />
                                    {
                                        this.state.detail && this.state.currentRoleId != 1 ?
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Nama Atasan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail && this.state.currentRoleId != 1 ?
                                                            <>{this.state.detail.employee_wfh_atasan !== "" ? this.state.detail.employee_wfh_atasan : this.state.atasan}</>
                                                            : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            : ''
                                    }
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nomor Surat Keterangan WFH
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_wfh_letter_number !== "" ? this.state.detail.employee_wfh_letter_number : '-'}</>
                                                    : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            NIP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{(this.state.detail.employee_wfh_employee_nip && this.state.detail.employee_wfh_employee_nip != 0) ? this.state.detail.employee_wfh_employee_nip : (this.state.currentRoleId != 1 ? (this.state.userdata?.employee_nip || '-') : '-')}</>
                                                    : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{(this.state.detail.employee_wfh_employee_name) ? this.state.detail.employee_wfh_employee_name : (this.state.currentRoleId != 1 ? (this.state.userdata?.employee_full_name || '-') : '-')}</>
                                                    : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label className="col-md-3 col-form-label">File Surat Keterangan/Surat Tugas WFH</Label>
                                        <Col md="6">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.document !== null ?
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document?.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                            : '-'}
                                                    </>
                                                    :
                                                    <Shimmer><div style={{ width: '30%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tanggal WFH
                                        </label>
                                        <Col md="6">
                                            <Table className="table-bordered table-striped">
                                                <thead>
                                                    <tr>
                                                        <th>No</th>
                                                        <th>Tanggal</th>

                                                        {
                                                            (this.state.currentRoleId != 1 || (this.state.currentRoleId == 1 && this.state.detail?.employee_wfh_employee_name != 'Semua Pegawai')) ? (
                                                                <>
                                                                    <th>Status Laporan</th>
                                                                    {/* <th>Status Approval</th> */}
                                                                </>
                                                            ) : ''
                                                        }
                                                        {
                                                            // ((this.state.detail?.employee_wfh_employee_nip == 0 || this.state.detail?.employee_wfh_employee_nip == "0" || this.state.detail?.employee_wfh_employee_nip == '0')) && (
                                                            <th>
                                                                Aksi
                                                            </th>
                                                            // )
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.detail?.reportdetail.length > 0 ?

                                                            this.state.detail?.reportdetail.map((data, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>{index += 1}</td>
                                                                        <td>{this.dateParse(data.employee_wfh_detail_date)}</td>
                                                                        <td>{(this.state.detail?.employee_wfh_employee_uuid && this.state.detail?.employee_wfh_employee_uuid != 0 && this.state.detail?.employee_wfh_employee_nip && this.state.detail?.employee_wfh_employee_nip != 0) ? data.employee_wfh_detail_report_status : (data.is_report_employee > 0 ? 'Sudah Mengisi' : 'Belum Mengisi')}</td>
                                                                        <td>
                                                                            {(this.state.detail?.employee_wfh_employee_uuid && this.state.detail?.employee_wfh_employee_uuid != 0 && this.state.detail?.employee_wfh_employee_nip && this.state.detail?.employee_wfh_employee_nip != 0) ? <label className={`badge rounded-pill font-size-12 ${data.employee_wfh_detail_status_class}`}>{data.employee_wfh_detail_status_name}</label> : (data.is_report_employee > 0 ? <label className="badge rounded-pill bg-soft-success font-size-12">Selesai</label> : <label className="badge rounded-pill bg-soft-warning font-size-12">Draft</label>)}
                                                                        </td>
                                                                        {
                                                                            (this.state.detail?.employee_wfh_employee_uuid == 0 && this.state.detail?.employee_wfh_employee_nip == 0) ? "" :
                                                                                <td>
                                                                                    {data?.employee_wfh_report_uuid > 0 ? 'Ya' : 'Tidak'}
                                                                                </td>
                                                                        }
                                                                        <td className='text-center'>
                                                                            {
                                                                                (this.state.detail?.employee_wfh_employee_uuid && this.state.detail?.employee_wfh_employee_uuid != 0 && this.state.detail?.employee_wfh_employee_nip && this.state.detail?.employee_wfh_employee_nip != 0) ?
                                                                                    data.employee_wfh_detail_status == 2 ?
                                                                                        <button
                                                                                            className="btn btn-primary btn-sm"
                                                                                            type='button'
                                                                                            id={"report-" + data.employee_wfh_detail_id}
                                                                                            onClick={() => {
                                                                                                this.setState({
                                                                                                    reportDetail: data,
                                                                                                })
                                                                                                this.toggleDetail()
                                                                                            }}
                                                                                            style={{
                                                                                                padding: '2px 5px'
                                                                                            }}>
                                                                                            <i className="uil-align-left"></i>
                                                                                        </button>
                                                                                        :
                                                                                        '-'
                                                                                    :
                                                                                    <Fragment>
                                                                                        {
                                                                                            data.is_report_employee > 0 ?
                                                                                                <button
                                                                                                    className="btn btn-primary btn-sm"
                                                                                                    type='button'
                                                                                                    id={"report-" + data.employee_wfh_detail_id}
                                                                                                    onClick={() => {
                                                                                                        this.setState({
                                                                                                            reportDetail: data,
                                                                                                            desc: data?.employee_wfh_report_description,
                                                                                                        })
                                                                                                        this.toggleDetail()
                                                                                                    }}
                                                                                                    style={{
                                                                                                        padding: '2px 5px'
                                                                                                    }}>
                                                                                                    <i className="uil-align-left"></i>
                                                                                                </button>
                                                                                                : ''}
                                                                                        {' '}

                                                                                    </Fragment>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })

                                                            :
                                                            <tr>
                                                                <td colSpan="6" className="text-center">Tidak Ada Data</td>
                                                            </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.employee_wfh_status_name !== "" ?
                                                                <label className={`badge rounded-pill ${this.state.detail.employee_wfh_status_class} font-size-12`}>{this.state.detail.employee_wfh_status_name}</label>
                                                                : '-'
                                                        }
                                                    </>
                                                    : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    {
                                        (this.state.detail && this.state.detail.employee_wfh_status == -1) ?
                                            <Row className="mb-3">
                                                <label className="col-md-3">
                                                    Alasan Penolakan
                                                </label>
                                                <Col md="9">
                                                    {
                                                        this.state.detail ?
                                                            <>
                                                                {
                                                                    this.state.detail.employee_wfh_status_description !== "" ?
                                                                        this.state.detail.employee_wfh_status_description
                                                                        : '-'
                                                                }
                                                            </>
                                                            : <Shimmer><div style={{ width: '50%', height: 15 }}></div></Shimmer>
                                                    }
                                                </Col>
                                            </Row>
                                            : ''
                                    }
                                    <hr />

                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/pengajuan_wfh.html" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                {this.state.detailUuid ?
                    <Redirect to={`/kepegawaian/pengajuan_wfh.html?detail_wfhall&uuid=${this.state.detailUuid}`} />
                    : null}

                <ReportDetailModal
                    modal={this.state.modalDetail}
                    toggle={() => this.toggleDetail()}
                    // periodUuid={this.state.period?.cpns_period_uuid} 
                    // setUuid={value => this.setUuid(value)} 
                    handleReload={() => this.setTokenAPI()}
                    nip={this.state.reportDetail?.employee_nip || this.state.reportDetail?.employee_wfh_report_nip || this.state.detail?.employee_nip}
                    reportDetail={this.state.reportDetail}
                    desc={this.state.desc}
                />
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);